import { news_sendBroadcastNotification } from '../components/news_sendBroadcastNotification'



export async function preUpdate(entity, data, id) {

    var d = {...data}

    if(entity === 'sample') {
        d.sample1 = 'test'
    }

    if(entity === 'news'){
        return await news_sendBroadcastNotification(d, 'update', id)
    }
    
    return {
        success: 1,
        data: d,
        message: ''
    }
}